export const DEFAULT_INACTIVE_PERIOD = 60*60*1000;
export const DEFAULT_INACTIVE_THROTTLE = 1200;